/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import isArray from 'lodash/isArray';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import styles from './styles';
import { withStyles } from 'tss-react/mui';
// The tab title is text. Pages whose `name` is an element (the seafarer
// card, the vessel card, the crew change) set their own title — or pass
// `title` — and writing the element here turned the tab into
// "[object Object]" on every re-render.
const pageTitle = ({ title, name }) => {
  const text = title || name;
  return typeof text === 'string' && text ? text : null;
};

class PageToolbar extends React.Component {
  componentDidMount() {
    const text = pageTitle(this.props);

    if (text) document.title = text;
  }

  componentDidUpdate(prevProps) {
    const text = pageTitle(this.props);

    if (text && text !== pageTitle(prevProps)) {
      document.title = text;
    }
  }

  render() {
    const { classes, name, children, className, style } = this.props;

    return (
      <Paper elevation={0} className={`${classes.root} ${className}`} style={style}>
        <div className={classes.title}>
          <Typography variant="h5" id="tableTitle">
            {name}
          </Typography>
        </div>
        <div className={classes.spacer} />
        <div className={classes.actions}>
          {isArray(children) ? children.map((child, index) => (
            <div key={index} className={classes.action}>
              {child}
            </div>
          )) : (
            <div className={classes.action}>
              {children}
            </div>
          )}
        </div>
      </Paper>
    );
  }
}

PageToolbar.propTypes = {
  name: PropTypes.any,
  title: PropTypes.string,
  children: PropTypes.any,
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
};

PageToolbar.defaultProps = {
  name: '',
  title: '',
  children: null,
  className: '',
  style: {},
};

export default withStyles(PageToolbar, styles);
